import QRCode from 'qrcode'
import { showErrorMessage, showSuccessMessage } from 'uiComponents/message'
import { Parkmap } from '../models'
import * as config from 'config'
import { t } from 'translations'

const guestAppEndpoint = config.getRequired('guest-app-endpoint')

export const copyQrCodeToClipboard = async (parkMap: Parkmap, accountSlug: string) => {
    const mapUrl = `${guestAppEndpoint}${accountSlug}/parkmap/${parkMap.locationId}`
    try {
        const canvas = document.createElement('canvas')
        await QRCode.toCanvas(canvas, mapUrl, { width: 512 })
        const blob = await new Promise<Blob>((resolve, reject) => {
            canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Failed to create blob'))), 'image/png')
        })
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })])
        showSuccessMessage(t('venue.parkMap.messages.qrCodeCopied'), 'copy_qr_code')
    } catch {
        showErrorMessage(t('venue.parkMap.messages.qrCodeCopyError'), 'copy_qr_code')
    }
}

export const copyMapUrlToClipboard = async (parkMap: Parkmap, accountSlug: string) => {
    const mapUrl = `${guestAppEndpoint}${accountSlug}/parkmap/${parkMap.locationId}`
    try {
        await navigator.clipboard.writeText(mapUrl)
        showSuccessMessage(t('venue.parkMap.messages.mapUrlCopied'), 'copy_map_url')
    } catch {
        showErrorMessage(t('venue.parkMap.messages.mapUrlCopyError'), 'copy_map_url')
    }
}
